import React from 'react';
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import Banner from "../../../../../assets/images/BreachRisk-Score-Banner.svg";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useSelector} from "react-redux";
import TileBreachRiskScoreWithBasicDial
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskScoreWithBasicDial";
import TileBreachRiskScoreMeta from "../../../../../components/customBreachBits/metrics/TileBreachRiskScoreMeta";
import RenderLineChart from "../../../../../components/customBreachBits/charts/BreachRiskScoreLineChart";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbIsEntityAwaitingFirstScoreCycle, bbTranslateBreachRiskScoreToCategory, bbTranslateBreachRiskScoreToColor
} from "../../../../../util/bbHelpers";
import BRBusinessAttacksAuthorizedToggleSwitchWidget from "../../../../../components/customBreachBits/controllers/BRBusinessAttacksAuthorizedControlWidget"
import BreachRiskScoreCyclePendingModal
    from "../../../../../components/customBreachBits/modals/BreachRiskScoreCyclePendingModal";
// import {BRBusinessTourScore} from './BRBusinessTourScore'
import {Badge, Col, Row} from "reactstrap";
import BRFidelityBadge from "../../../../../components/customBreachBits/BRPortfolio/BRFidelityBadge";
// import BRPendingRequestNotification
//     from "../../../../../components/customBreachBits/BreachRiskReport/BRPendingRequestNotification";
import BRSocialEngineeringAuthorizationWidget
    from "../../../../../components/customBreachBits/BRSocialReports/BRSocialEngineeringAuthorizationWidget";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import CycleProgressStepper from "../../../../../components/customBreachBits/info/CycleProgressStepper";
import Widget from "../../../../../components/prefabricated/Widget";
import TileBreachRiskReportVectorSummaryBranch
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskReportVectorSummaryBranch";
import TileMinimalistBRScoreCollateralRiskFact
    from "../../../../../components/customBreachBits/metrics/TileMinimalistBRScoreCollateralRiskFact";
import AttackSurfaceRadarChart from "../../../../../components/customBreachBits/charts/AttackSurfaceRadarChart";
import RiskComparisonFactBar from "../../../../../components/customBreachBits/charts/RiskComparisonFactBar";
import BBBoxplotFact from "../../../../../components/customBreachBits/charts/BBBoxplotFact";
import BRCompanyScopeProgressBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScopeProgressBadge";
import BRCompanyScoreVerifiedBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScoreVerifiedBadge";
import BRRiskBenchMarkWidget from "../../../../../components/customBreachBits/charts/BRRiskBenchMarkWidget";

const Page= ({
    portfolioView = false
             }) => {

    const { customers, customerInView} = useSelector(({customer}) => customer);
    const {authUser, startProductTour, loadingStartProductTour, startProductTourError} = useSelector(({auth}) => auth);

    const {entityInView, portfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const lastCycle = myEntity ? myEntity.last_cycle : null
    const lastCycleDateTime = myEntity && myEntity.last_cycle ? myEntity.last_cycle.cycle_datetime : null;

    const breachRiskScore = myEntity && myEntity.last_cycle ? myEntity.last_cycle.score: null;
    const breachRiskCategory = bbTranslateBreachRiskScoreToCategory(breachRiskScore);

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    // console.log("looking at these elements of state-- startProductTour", startProductTour, "startProductTourError", startProductTourError, "loadingStartProductTour", loadingStartProductTour, "portfolios", portfolios)


    const isWaitingForFirstScore = bbIsEntityAwaitingFirstScoreCycle(myEntity);

    const isCycleOngoing = myEntity
        && myEntity.settings
        && myEntity.settings.ongoing_cycle_complete_datetime;

    const responsivenessData = myEntity
    && myEntity.last_cycle
    && myEntity.last_cycle.vector_summary
    && myEntity.last_cycle.vector_summary.high_risk_vector_responsiveness
        ? myEntity.last_cycle.vector_summary.high_risk_vector_responsiveness
        : null;

    const responsivenessAvg = responsivenessData && responsivenessData.average_days_since_discovery;
    const responsivenessMin = responsivenessData && responsivenessData.minimum_days_since_discovery;
    const responsivenessMax = responsivenessData && responsivenessData.maximum_days_since_discovery;

    console.log("Reading responsiveness data. Got this", responsivenessData, responsivenessAvg, responsivenessMin, responsivenessMax);


    return (
        <div className="app-wrapper">
            <div className="animated fadeIn animation-duration-7">
          {/*<BRBusinessTourScore portfolioView={portfolioView}/>*/}

          <Row id={"tourBRScoreHeading"}>
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                      <h3 className={"tourBRPortEntityName"}>
                          {!isWaitingForFirstScore
                              && <>{myEntity && lastCycleDateTime
                                  ? bbFormattedDateString(lastCycleDateTime, "shortFullMonth")
                                  : ""} | </>}
                          {myEntity ? myEntity.name : ""}
                          <span>
                              <BRCompanyScoreVerifiedBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.0em"}
                                  inline
                              />
                          </span></h3>

                      <h2>
                          {/*<Tooltip title={`This BreachRisk™ Score is ${parseFloat(breachRiskScore).toFixed(1)} out of 10. Higher numbers indicate a higher relative risk that a cyber breach will occur in the foreseeable future.`}>*/}
                              <span>BreachRisk™ Score: <strong>{parseFloat(breachRiskScore).toFixed(1)}</strong><small> /10</small></span>
                          {/*</Tooltip> */}
                      &nbsp;

                          <Tooltip heading={"Risk Categories"}
                                   width={"400px"}
                                   examples={[
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-lowest"}>Very Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-low"}>Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-medium"}>Medium Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-high"}>High Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-highest"}>Very High Risk</Badge></p>,
                                           text: null,},
                                   ]}>
                              <span className={"tourBRScoreRiskCategory"}><Badge color={bbTranslateBreachRiskScoreToColor(breachRiskScore)}>{breachRiskCategory} Risk</Badge>
                                      </span>
                          </Tooltip> &nbsp;

                          <span className={"tourBRScoreFidelity"}>{myEntity ? <BRFidelityBadge cycleObject={lastCycle}/> : <> </>}</span>
                          <span>
                              <BRCompanyScopeProgressBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.5em"}
                                  inline
                              />
                          </span>

                      </h2>

                  </div>
              </div>
              <div className={"col-4 align-self-center tourStepFour"}>
                  <h3>Predict a breach, avoid a breach.™ <Tooltip heading={`BreachRisk Score`} link={'https://www.breachbits.com/about-breachrisk'}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                  <p>BreachRisk™ Score communicates cyber risks fairly using a 10-point scale. A higher number indicates a higher relative risk of a cyber breach.</p>
                  {isCycleOngoing
                    ?   <h5>Next Score Determination Available: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.ongoing_cycle_complete_datetime, "shortFullMonth") : ""}</h5>

                      : <h5>Next Assessment Start: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.next_cycle_datetime, "shortFullMonth") : ""}</h5>
                  }
                  <CycleProgressStepper/>

              </div>
          </Row>
          <hr/>

          <BreachRiskScoreCyclePendingModal isBRPView={portfolioView}>
              {(selfEntityId === entityInView || isAdministratorForThisEntity) &&
                  <Row>
                      <div className="col-6 tourBRHighFidelityTesting" id={"tourBRHighFidelityTesting"}>
                          <BRBusinessAttacksAuthorizedToggleSwitchWidget brLevelRequired={"infoLevel4"} brSubscriptionRequired={isTrustedAgentForThisEntity ? "Pro" : null}/>
                      </div>

                      <div className="col-6 tourBRSocialTestingAuthorization" id={"tourBRSocialTestingAuthorization"}>
                          <BRSocialEngineeringAuthorizationWidget brSubscriptionRequired={isTrustedAgentForThisEntity ? "Premium" : null}/>
                      </div>
                  </Row>
              }

                  <Row id={"tourBRScoreDialRow"}>
                      <Col className={`${portfolioView ? "col-5" : "col-7"}`} >
                          <TileBreachRiskScoreWithBasicDial entityId={entityInView} />
                      </Col>

                      <Col id={"tourBRRiskBenchmarks"} className={`${portfolioView ? "col-3" : "col-5"} align-self-center`}>
                          <BRRiskBenchMarkWidget/>
                      </Col>
                      {portfolioView
                        ?
                      <Col className={"col-4 align-self-center" } id={"tourAttackSurfaceRadarChart"}>
                          <AttackSurfaceRadarChart/>
                      </Col>
                      :null}
                  </Row>
              {portfolioView
                ? <section>
                      <Row id={"tourPortfolioRIskEnvironmentWidgetRows"}>
                          <Col id={"tourPortfolioRiskCol"}>
                              <Widget className={""} styleName={`px-3 pt-3 pb-0 bg-light animated fadeIn animation-duration-5 dataTile tourPortfolioRiskWidget`}>
                                  <h2>Risk Environment: Threat Vectors</h2>
                                  <p>BreachRisk™ Score is based on actual hacker attack pathways we have discovered. We describe these Threat Vectors in the language of risk: difficulty of the attack and expected damage upon success.</p>
                                  <Row>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"severity"}
                                              varName = {"high"}
                                              subTitle = {"High Risk"}
                                              tipText = {"Attackers are highly attracted to high-risk threats because they can be exploited within days to weeks, and usually allow the attacker to do a large amount of damage."}
                                              // icon = {<></>}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}
                                          />
                                      </Col>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"severity"}
                                              varName = {"medium"}
                                              subTitle = {"Medium Risk"}
                                              tipText = {"Attackers will usually attempt to exploit medium risk threats because they allow the attacker to do a moderate amount to damage. A dedicated attacker could probably succeed within 3-6 months."}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}

                                          />
                                      </Col>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"severity"}
                                              varName = {"low"}
                                              subTitle = {"Low Risk"}
                                              tipText = {"Attackers don't spend a lot of resources attempting to exploit low risk threats, but a dedicated attacker may eventually succeed."}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}

                                          />
                                      </Col>
                                  </Row>
                              </Widget>
                          </Col>

                          <Col id={"tourPortfolioOpportunitiesCol"}>
                              <Widget styleName={`px-3 pt-3 pb-0 bg-light animated fadeIn animation-duration-5 dataTile tourPortfolioOpportunitiesWidget`} >
                                  <h2>Opportunities: Options for Attackers</h2>
                                  <p>This illuminates how attackers might plan to breach this organization. Attackers use different techniques for each type of threat. Defenders need different approaches to mitigate or eliminate them.</p>

                                  <Row>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"types"}
                                              varName = {"credential"}
                                              subTitle = {"Credential"}
                                              tipText = {"Attackers exploit credential-based threats using techniques like password spraying, stolen credentials, and brute force. These are usually fixed by obfuscating the login access point or implementing multi-factor authentication or other security controls to detect anomalies and intruders masquerading as legitimate users."}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}
                                              className={'tourPortfolioOpportunitiesWidget'}
                                          />
                                      </Col>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"types"}
                                              varName = {"misconfiguration"}
                                              subTitle = {"Misconfiguration"}
                                              tipText = {"Attackers exploit configuration-based threats using techniques that take advantage of unintended ways the computer or server has been set up or programmed to perform. The defender's software is performing normally, but they have overlooked a setting that allows undesirable actions. These are usually fixed by correcting the misconfiguration."}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}

                                          />
                                      </Col>
                                      <Col>
                                          <TileBreachRiskReportVectorSummaryBranch
                                              summaryDataBranch = {"types"}
                                              varName = {"vulnerability"}
                                              subTitle = {"Vulnerability"}
                                              tipText = {"Attackers exploit vulnerability-based threats using a series of actions and tools that rely on known computer vulnerabilities or bugs that allow the attacker to do something unexpected. These can sometimes be patched with software updates."}
                                              linkOverridePathnameHash={portfolioView && {pathname:`/board/BreachRisk/Portfolio/Details/Reports`, hash:`threatsSummaryTable`}}

                                          />
                                      </Col>
                                  </Row>
                              </Widget>
                          </Col>
                      </Row>
                  </section>
                  :null
              }

              <Row className="row" id={"tourBRScoreHistory"}>

                  <Col className="col-12 tourBRScoreHistory">
                      <RenderLineChart chartData = {null}  entityId={entityInView}/>
                  </Col>

              </Row>

              {portfolioView
                  ? <section>
                      <h2 className={"text-center"} id={"tourBRAttackSurfaceWidgetsPortfolio"}>Attack Surface</h2>
                      <hr/>
                      <Row className={"tourBRAttackSurfaceRow"}>
                          <Col>
                              <AttackSurfaceRadarChart
                                  small
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"vectors"}
                                  subTitle={"Vectors"}
                                  tipText={"The number of viable Threat Vectors that provide opportunities for attackers."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"vulnerabilities"}
                                  subTitle={"Vulnerabilities"}
                                  tipText={"The number of Common Vulnerabilities or Exposures (CVEs) from the NVD."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"services_high_risk"}
                                  subTitle={"High Risk Services"}
                                  tipText={"The number of services detected that attackers would consider to be high risk."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"services"}
                                  subTitle={"Services"}
                                  tipText={"The total number of services found for this entity."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"targets"}
                                  subTitle={"Hosts"}
                                  tipText={"The total number of hosts that attackers can target from the public internet."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"identities"}
                                  subTitle={"Identities"}
                                  tipText={"The total number of identities (e.g. humans), email addresses, or handles that attackers can target with social engineering."}
                              />
                          </Col>

                          <Col>
                              <TileMinimalistBRScoreCollateralRiskFact
                                  varName={"subdomains"}
                                  subTitle={"Subdomains"}
                                  tipText={"The number of subdomains found for this entity."}
                              />
                          </Col>
                      </Row>

                  </section>
                  :null}

              {!portfolioView
                  ? <section>
                  <h2 className={"text-center"} id={"tourBRAttackSurfaceHeading"}>Attack Surface</h2>
                  <hr/>
                  <Row>
                      <Col>
                          <AttackSurfaceRadarChart
                              small
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"vectors"}
                              subTitle={"Vectors"}
                              tipText={"The number of viable Threat Vectors that provide opportunities for attackers."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"vulnerabilities"}
                              subTitle={"Vulnerabilities"}
                              tipText={"The number of Common Vulnerabilities or Exposures (CVEs) from the NVD."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"services_high_risk"}
                              subTitle={"High Risk Services"}
                              tipText={"The number of services detected that attackers would consider to be high risk."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"services"}
                              subTitle={"Services"}
                              tipText={"The total number of services found for this entity."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"targets"}
                              subTitle={"Hosts"}
                              tipText={"The total number of hosts that attackers can target from the public internet."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"identities"}
                              subTitle={"Identities"}
                              tipText={"The total number of identities (e.g. humans), email addresses, or handles that attackers can target with social engineering."}
                          />
                      </Col>

                      <Col>
                          <TileMinimalistBRScoreCollateralRiskFact
                              varName={"subdomains"}
                              subTitle={"Subdomains"}
                              tipText={"The number of subdomains found for this entity."}
                          />
                      </Col>
                  </Row>
                  <Row>
                      <div className="col-6 align-self-center" >
                          <Row>
                              <Col>
                                  <br/>
                              </Col>
                          </Row>
                          <Row id={"tourBRAttackSurfaceBenchmarks"}>
                              <Col>
                                  <AttackSurfaceRadarChart/>

                              </Col>
                          </Row>
                      </div>
                      <div className={"col-6 align-self-center"}>
                          <Row id={"tourBRRiskEnvironmentRow"}>
                              <Col className={"tourBRRiskEnvironmentWidgets"} id={"tourBRRiskCountCol"}>
                                  <Widget styleName={`px-3 pt-3 pb-0 bg-light animated fadeIn animation-duration-5 dataTile `}>
                                      <h2>Risk Environment: Threat Vectors</h2>
                                      <p>BreachRisk™ Score is based on actual hacker attack pathways we have discovered. We describe these Threat Vectors in the language of risk: difficulty of the attack and expected damage upon success.</p>
                                      <Row>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"severity"}
                                                  varName = {"high"}
                                                  subTitle = {"High Risk"}
                                                  tipText = {"Attackers are highly attracted to high-risk threats because they can be exploited within days to weeks, and usually allow the attacker to do a large amount of damage."}
                                                  // icon = {<></>}
                                              />
                                          </Col>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"severity"}
                                                  varName = {"medium"}
                                                  subTitle = {"Medium Risk"}
                                                  tipText = {"Attackers will usually attempt to exploit medium risk threats because they allow the attacker to do a moderate amount to damage. A dedicated attacker could probably succeed within 3-6 months."}
                                              />
                                          </Col>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"severity"}
                                                  varName = {"low"}
                                                  subTitle = {"Low Risk"}
                                                  tipText = {"Attackers don't spend a lot of resources attempting to exploit low risk threats, but a dedicated attacker may eventually succeed."}
                                              />
                                          </Col>
                                      </Row>
                                  </Widget>
                              </Col>
                          </Row>
                          <Row>
                              <Col className={"tourBRRiskOpportunitiesWidgets"} id={"tourBRRiskOpportunitiesCol"}>
                                  <Widget styleName={`px-3 pt-3 pb-0 bg-light animated fadeIn animation-duration-5 dataTile `} >
                                      <h2>Opportunities: Options for Attackers</h2>
                                      <p>This illuminates how attackers might plan to breach this organization. Attackers use different techniques for each type of threat. Defenders need different approaches to mitigate or eliminate them.</p>

                                      <Row>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"types"}
                                                  varName = {"credential"}
                                                  subTitle = {"Credential"}
                                                  tipText = {"Attackers exploit credential-based threats using techniques like password spraying, stolen credentials, and brute force. These are usually fixed by obfuscating the login access point or implementing multi-factor authentication or other security controls to detect anomalies and intruders masquerading as legitimate users."}
                                              />
                                          </Col>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"types"}
                                                  varName = {"misconfiguration"}
                                                  subTitle = {"Misconfiguration"}
                                                  tipText = {"Attackers exploit configuration-based threats using techniques that take advantage of unintended ways the computer or server has been set up or programmed to perform. The defender's software is performing normally, but they have overlooked a setting that allows undesirable actions. These are usually fixed by correcting the misconfiguration."}
                                              />
                                          </Col>
                                          <Col>
                                              <TileBreachRiskReportVectorSummaryBranch
                                                  summaryDataBranch = {"types"}
                                                  varName = {"vulnerability"}
                                                  subTitle = {"Vulnerability"}
                                                  tipText = {"Attackers exploit vulnerability-based threats using a series of actions and tools that rely on known computer vulnerabilities or bugs that allow the attacker to do something unexpected. These can sometimes be patched with software updates."}
                                              />
                                          </Col>
                                      </Row>
                                  </Widget>
                              </Col>
                          </Row>
                      </div>
                  </Row>
              </section>
              : null}

                      {/*<div className="row">*/}

                      {/*    <div className="col-12 tourBRScoreHistory">*/}
                      {/*        <RenderLineChart chartData = {null}  entityId={entityInView}/>*/}
                      {/*    </div>*/}

                      {/*</div>*/}
              {/*<div className="col-2">*/}



          </BreachRiskScoreCyclePendingModal>
          </div>

        </div>
    )
}
export default Page;